
import { MarketingHero } from "@/components/marketing/MarketingHero";
import { FeatureCards } from "@/components/marketing/FeatureCards";
import { HowItWorks } from "@/components/marketing/HowItWorks";
import { ParentsBenefits } from "@/components/marketing/ParentsBenefits";
import { PricingSection } from "@/components/marketing/PricingSection";
import { FinalCTA } from "@/components/marketing/FinalCTA";

const Marketing = () => {
  const marketingImages = {
    hero: "https://zcirxkvrqzsljzuoohey.supabase.co/storage/v1/object/public/marketing/pexels-rdne-5593641.jpg",
    cooking1: "https://zcirxkvrqzsljzuoohey.supabase.co/storage/v1/object/public/marketing/pexels-cottonbro-3992370.jpg",
    cooking2: "https://zcirxkvrqzsljzuoohey.supabase.co/storage/v1/object/public/marketing/pexels-ron-lach-8189430.jpg",
    cooking3: "https://zcirxkvrqzsljzuoohey.supabase.co/storage/v1/object/public/marketing/pexels-august-de-richelieu-4259707.jpg"
  };

  return (
    <div className="bg-gradient-to-br from-[#FFE29F] via-[#FFA99F] to-[#FF719A]">
      <div className="container mx-auto px-4 py-12">
        <MarketingHero heroImage={marketingImages.hero} />
        <FeatureCards images={marketingImages} />
        <HowItWorks />
        <ParentsBenefits />
        <PricingSection />
        <FinalCTA />
      </div>
    </div>
  );
};

export default Marketing;
